import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, Typography, Button } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import PAEVideo from "../assets/PAE.mp4";
import NewsletterSection from "../components/sections/NewsletterSection";

const stats = [
  { label: "Reducción estrés laboral" },
  { label: "Mejora clima laboral" },
  { label: "Incremento de productividad" },
  { label: "Reducción de ausentismo" },
  { label: "Reducción de fuga de talento" },
];

const pillarsFirstRow = [
  {
    slug: "accion-nom-035",
    title: "NOM-035",
    desc: "El costo de no atender el riesgo psicosocial en la empresa es incalculable.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    slug: "custom-care",
    title: "Customer CARE",
    desc: "Cálida atención a cliente 24/7 X 365.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    slug: "cobertura-completa",
    title: "Cobertura completa",
    desc: "De especialidades psicológicas y consultorías especializadas.",
    icon: (
      <img src="/map.svg" alt="Cobertura México" className="w-10 h-10 object-contain flex-shrink-0" />
    ),
  },
];

const pillarsSecondRow = [
  {
    slug: "well-being-coaching",
    title: "Well-being coaching fitness emocional.",
    desc: "Fortalecer su estabilidad emocional.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    slug: "webinars",
    title: "Webinars + Conferencias ON-SITE",
    desc: "Nos interesa ser un acompañamiento completo.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    slug: "cism",
    title: "CISM",
    desc: "Intervención en crisis.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    slug: "atencion-psicologica",
    title: "Atención Psicológica",
    desc: "Equipo de psicólogos especializados para atención profesional y personalizada.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
  },
  {
    slug: "consultoria-especializada",
    title: "Consultoría Especializada",
    desc: "Asesoría en Legal, Fiscal, Financiera, Nutricional y Liderazgo.",
    icon: (
      <svg className="w-10 h-10 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
];

const heroSlides = [
  {
    image: "/images/carousel1.jpg",
    title: "EAP Consulting",
    description: "Más que apoyo psicológico:\n\nsomos el impulso emocional que ayuda a sus empleados a crecer, superar desafíos y brillar en cada ambito de su vida.",
  },
  {
    image: "/images/carousel2.jpg",
    title: "Pioneros en México y agentes de inspiración.",
    description: "y cambio para más de 2.3 millones de personas, impulsando su equilibrio emocional y su capacidad para alcanzar sus metas personales y profesionales.",
  },
];

export default function Home() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVideoMuted, setIsVideoMuted] = useState(true);
  const videoRef = useRef(null);

  const handleCardClick = (slug) => {
    navigate(`/servicio/${slug}`);
  };

  useEffect(() => {
    setIsAnimating(false);
    const timer = setTimeout(() => setIsAnimating(true), 50);
    return () => clearTimeout(timer);
  }, [currentSlide]);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex flex-col w-full">
      {/* ── Hero carousel ── */}
      <section
        className="relative h-[400px] sm:h-[500px] md:h-[600px] w-full bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url('${heroSlides[currentSlide].image}')` }}
      >
        <div className="absolute inset-0 bg-brand-navy/50" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center">
          <div className="max-w-2xl text-white">
            <Typography
              key={`title-${currentSlide}`}
              variant="h2"
              className={`mb-4 font-normal text-3xl sm:text-4xl md:text-5xl lg:text-6xl transition-all duration-700 ease-in-out ${
                isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              {heroSlides[currentSlide].title}
            </Typography>
            <Typography
              key={`description-${currentSlide}`}
              variant="lead"
              className={`mb-8 font-light text-base md:text-lg leading-relaxed whitespace-pre-line transition-all duration-700 delay-150 ease-in-out ${
                isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
              }`}
            >
              {heroSlides[currentSlide].description}
            </Typography>
            <Button
              size="lg"
              className="bg-brand-lavender hover:bg-brand-navy border border-white/20 text-white rounded-none px-8 shadow-none hover:shadow-lg transition-all normal-case tracking-widest"
              onClick={() => navigate("/conozcanos")}
            >
              CONOCE MÁS →
            </Button>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-2 rounded-full transition-all ${
                currentSlide === index ? "w-6 bg-white" : "w-2 bg-white/50"
              }`}
            />
          ))}
        </div>
      </section>

      {/* ── Stats strip ── */}
      <section className="bg-brand-beige py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-5">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className="flex items-center justify-center rounded-xl border border-brand-lilac/60 bg-white px-4 py-5 sm:px-5 sm:py-6 text-center shadow-sm"
              >
                <Typography className="text-brand-navy font-semibold text-lg sm:text-xl md:text-[1.25rem] leading-snug tracking-tight max-w-[14rem] sm:max-w-none">
                  {stat.label}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Pillars ── */}
      <section className="bg-[#f0ebf0] py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <Typography variant="h3" className="text-brand-dark font-normal">
              Nuestros pilares con los
            </Typography>
            <Typography variant="h3" className="text-brand-lavender font-bold">
              que hacemos la diferencia.
            </Typography>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            {pillarsFirstRow.map((item, idx) => (
              <div key={idx} onClick={() => handleCardClick(item.slug)} className="cursor-pointer h-full">
                <PillarCard item={item} />
              </div>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            {pillarsSecondRow.map((item, idx) => (
              <div
                key={idx}
                onClick={() => handleCardClick(item.slug)}
                className="w-full md:w-[calc(50%-12px)] lg:w-[calc(33.33%-16px)] flex-grow-0 cursor-pointer"
              >
                <PillarCard item={item} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Video ── */}
      <section className="relative w-full flex items-center justify-center overflow-hidden bg-brand-navy">
        <div className="relative w-full" style={{ aspectRatio: "16/9", maxHeight: "600px" }}>
          <video
            ref={videoRef}
            autoPlay
            loop
            muted={isVideoMuted}
            playsInline
            className="w-full h-full object-contain"
          >
            <source src={PAEVideo} type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-brand-navy/20" />
          <button
            onClick={() => {
              setIsVideoMuted((v) => !v);
              if (videoRef.current) videoRef.current.muted = !isVideoMuted;
            }}
            className="absolute bottom-6 right-6 z-10 w-12 h-12 bg-brand-navy/60 hover:bg-brand-navy/80 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 backdrop-blur-sm"
            aria-label={isVideoMuted ? "Activar sonido" : "Silenciar"}
          >
            {isVideoMuted ? (
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
              </svg>
            ) : (
              <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
              </svg>
            )}
          </button>
        </div>
      </section>

      <NewsletterSection />
    </div>
  );
}

function PillarCard({ item }) {
  return (
    <Card className="h-full shadow-sm hover:shadow-md transition-shadow border border-brand-lilac/40 rounded-xl">
      <CardBody className="flex flex-col items-center text-center p-8 h-full">
        <div className="mb-4 w-16 h-16 rounded-full bg-brand-lilac/30 flex items-center justify-center shrink-0">
          {item.icon}
        </div>
        <Typography variant="h6" className="mb-2 font-bold text-brand-navy">
          {item.title}
        </Typography>
        <Typography className="text-brand-gray text-sm mb-6 flex-grow">
          {item.desc}
        </Typography>
        <div className="mt-auto border border-brand-lavender/40 rounded px-4 py-1">
          <svg className="w-4 h-4 text-brand-lavender" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
      </CardBody>
    </Card>
  );
}
